import { render, staticRenderFns } from "./AlertHandler.vue?vue&type=template&id=72456a3a&"
import script from "./AlertHandler.vue?vue&type=script&lang=js&"
export * from "./AlertHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports